import { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import { Optional } from 'lib/types/Optional';

export class VncModalSelectors {
  public static selectVncModalStatusIsVisible = (state: IState): Optional<boolean> =>
    state['cross-cutting-concerns']['vnc-feature'].modals.vncModalStatus.isVisible;

  public static selectVncModalExpirationIsVisible = (state: IState): Optional<boolean> =>
    state['cross-cutting-concerns']['vnc-feature'].modals.vncModalExpiration.isVisible;

  public static selectVncModalWarningOneIsOpenAlreadyIsVisible = (state: IState): Optional<boolean> =>
    state['cross-cutting-concerns']['vnc-feature'].modals.vncModalWarningOneIsOpenAlready.isVisible;

  public static selectVncModalWarningOneIsOpenAlreadyMachineId = (state: IState): Optional<string> =>
    state['cross-cutting-concerns']['vnc-feature'].modals.vncModalWarningOneIsOpenAlready.machineId;

  public static selectVncModalWarningOneIsOpenAlreadySoftwareVersion = (state: IState): Optional<string> =>
    state['cross-cutting-concerns']['vnc-feature'].modals.vncModalWarningOneIsOpenAlready.softwareVersion;

  public static selectVncModalWarningOneIsOpenAlreadySerialNumber = (state: IState): Optional<string> =>
    state['cross-cutting-concerns']['vnc-feature'].modals.vncModalWarningOneIsOpenAlready.serialNumber;
}
